module.exports = function(service) {
	'use strict'
	service.factory('keyPressOnlyNumberAndEnter', keyPressOnlyNumberAndEnter);
	keyPressOnlyNumberAndEnter.$inject = [];
	function keyPressOnlyNumberAndEnter() {
	   return function(evt,enterCb,searchdata) {
			evt = (evt) ? evt : event;
		    var charCode = (evt.charCode) ? evt.charCode : ((evt.keyCode) ? evt.keyCode :
		    ((evt.which) ? evt.which : 0));
            if(charCode == 13) {
                enterCb(searchdata)
            }
		    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
		        evt.preventDefault();
		    }
	   }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/keyPressOnlyNumberAndEnterService.js
// module id = 613
// module chunks = 0